import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import userReducer from "./user/userSlice";
import parkingReducer from "./parking/parkingSlice";
import driverReducer from "./driver/driver";
import vehicleReducer from "./vehicle/vehicleSlice";
import subscriptionReducer from "./subscription/subscriptionSlice";
import reservationReducer from "./reservation/reservationSlice";
import ticketCategoriesReducer from "./categoryReclamation/categoryReclmation";
import PartnerReservationReducer from "./partnerReservation/partnerReservationSlice";
import paymentReducer from "./payment/paymentSlice";
import tarifReducer from "./tarif/tarifSlice";
import serviceReducer from "./services/serviceSlice";
import reducerReducer from "./city/citySlice";
import logicalEntityReucer from "./logicalEntity/logicalEntitySlice";
import PartnerSubscriptionReducer from "./partnerSubscription/partnerSubscriptionSlice";
import reclamationReducer from "./reclamation/reclamation";
import cardSlice from "./card/cardSlice";
import vatSlice from "./vat/vatSlice";
import ldReservationReducer from "./LDReservation/ldReservationSlice";
import PartnerEmailTemplatesReducer from "./partnerEmailTemplates/partnerEmailTemplatesSlice";
import uclReservationReducer from "./uclReservation/uclReservationSlice";
import uclSubscriptionReducer from "./uclSubscription/uclSubscriptionSlice";
import cartReducer from "./cart/cartItem";

// Augment middleware to consider Immutable.JS iterables serializable
export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    parking: parkingReducer,
    driver: driverReducer,
    vehicle: vehicleReducer,
    subscription: subscriptionReducer,
    reservation: reservationReducer,
    ticketCategories: ticketCategoriesReducer,
    PartnerReservationReducer: PartnerReservationReducer,
    worldlinePayment: paymentReducer,
    tarif: tarifReducer,
    service: serviceReducer,
    city: reducerReducer,
    logicalEntity: logicalEntityReucer,
    PartnerSubscription: PartnerSubscriptionReducer,
    reclamation: reclamationReducer,
    card: cardSlice,
    vat: vatSlice,
    ldReservation: ldReservationReducer,
    PartnerEmailTemplates: PartnerEmailTemplatesReducer,
    uclReservation: uclReservationReducer,
    uclSubscription: uclSubscriptionReducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
